import {defineStore} from 'pinia';
import {ModuleBankInfo} from '../moduleConst';
import bankInfoAPI from '@/apis/di/bankInfoAPI';
import {BaseDictionaryStore} from '@/stores/baseDictionaryStore';
const bankInfoStore = new BaseDictionaryStore(bankInfoAPI);
export const useBankInfoStore = defineStore(ModuleBankInfo, {
  state: () => ({
    ...bankInfoStore.state,
    _config: {
      key: 'bank_info_id',
      code: 'bank_account',
      name: 'bank_name',
      table: 'di_bank_info',
      quickFollow: 'active',
      moduleName: 'Tài khoản ngân hàng, kho bạc',
      defaultSort: 'bank_account',
    },
    moduleName: 'diBankInfo',
  }),
  actions: {...bankInfoStore.action},
  getters: {
    ...bankInfoStore.getters,
  },
});
